import { IGetAssistantTableConfigArgs } from '@f_qwep/components/assistant/view/table/AssistantColumn.config';
import Tooltip from '@mui/material/Tooltip';
import { EAssistantItemStatus } from '../../../types/assistant-profile.type';
import { useAssistantStatus } from '../useAssistantStatus';

interface IAssistantAvailabilityColumnProps extends Omit<IGetAssistantTableConfigArgs, 't'> {
    averageAvailability: number;
    state: EAssistantItemStatus;
    promo: boolean;
}

export const AssistantAvailabilityColumn = (props: IAssistantAvailabilityColumnProps) => {
    const { averageAvailability, state, promo } = props;
    const { textColor } = useAssistantStatus(state, promo);
    return (
        <Tooltip title={averageAvailability}>
            <p
                style={{
                    color: textColor,
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                {averageAvailability ? averageAvailability : '-'}
            </p>
        </Tooltip>
    );
};
